import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../state/hooks';
import { IncidentListPageQuery } from './incidentList.queryParams.interface';

export interface IncidentListPageQueryState {
  queryParams: IncidentListPageQuery;
}

const initialState: IncidentListPageQueryState = {
  queryParams: {},
};

/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state"] }] */
export const incidentListPageQuerySlice = createSlice({
  name: 'incidentListPageQuery',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    dispatchPageQuery(
      state,
      action: PayloadAction<Partial<IncidentListPageQuery>>,
    ) {
      // TODO: what if we want to clear all before adding payload?
      // TODO: Maybe we need to only update queryParams if they have changed because (if) all memoized selectors (i.e. createSelectors(...)) are recalculated by reference rather then by value?
      // TODO: ALLOW SENDING IN AN EMPTY QUERYPARAM OBJECT. AT THE MOMENT IT DOESN'T OVERRIDE
      state.queryParams = {
        ...state.queryParams,
        ...action.payload,
      };
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {},
});

export const { dispatchPageQuery } = incidentListPageQuerySlice.actions;

export const incidentListPageQuerySelector = (
  state: RootState,
): IncidentListPageQuery => {
  return state.incidentListPageQuery.queryParams;
};
